module.exports = __webpack_public_path__ + "media/images/icons/road-3d5538ef6b8b00c0991eba0315911366.svg";